/** Community kiosk / station portal under /mishtameret/station */

export const PERSONAL_BASE = '/mishtameret';
export const STATION_BASE = '/mishtameret/station';

export function isStationPath(pathname = '') {
  const p = String(pathname);
  return p === STATION_BASE || p.startsWith(`${STATION_BASE}/`);
}

export function portalBase(isStation) {
  return isStation ? STATION_BASE : PERSONAL_BASE;
}

/**
 * @param {boolean} isStation
 * @param {string} [suffix] e.g. '/exams', 'grades', '/login'
 */
export function portalPath(isStation, suffix = '') {
  const base = portalBase(isStation);
  if (!suffix) return base;
  const clean = String(suffix).startsWith('/') ? suffix : `/${suffix}`;
  return `${base}${clean}`;
}

/** Theme for shared tablets — system preference only, never localStorage */
export function getStationThemeMode() {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  }
  return 'dark';
}
